module.exports = __webpack_public_path__ + "img/pleisure_bodyimage11.1a743166.jpg";